import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user, isAuthenticated, loading, deviceStatus } = useAuth();
  const location = useLocation();

  // If user data is passed via navigation state, skip loading
  if (location.state?.user) {
    return children;
  }

  // If user is already set in context (e.g. from login), render immediately
  if (user) {
    // Check device status — redirect if unregistered or blocked (except Super Admin)
    if (user.role !== "super_admin" && (deviceStatus === "unregistered" || deviceStatus === "blocked" || deviceStatus === "no_token")) {
      if (location.pathname !== "/device-pending") {
        return <Navigate to="/device-pending" replace />;
      }
    }
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary" />
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
